class o{triggerModelLoading(){this.modelLoadingPromise=this.loadModels()}}export{o as FaceDetection};
